import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import Loading from '../loading';

// load mathjax.js first before show editor
var LoadScript = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadScript, _React$Component);
  var _super = _createSuper(LoadScript);
  function LoadScript(props) {
    var _this;
    _classCallCheck(this, LoadScript);
    _this = _super.call(this, props);
    _this.loadScript = function () {
      if (!_this.props.scriptSource) return;
      if (!document.querySelector('#mathjax')) {
        var script = document.createElement('script');
        script.src = _this.props.scriptSource;
        script.id = 'mathjax';
        document.body.appendChild(script);
        script.onload = function () {
          _this.setState({
            isScriptLoaded: true
          });
        };
      }
    };
    if (!props.scriptSource || window.MathJax) {
      _this.state = {
        isScriptLoaded: true
      };
      return _possibleConstructorReturn(_this);
    }
    window.canInsertFormula = true;
    if (!window.MathJax) {
      // config mathjax
      window.MathJax = {
        options: {
          enableMenu: false
        },
        tex: {
          inlineMath: [['$', '$']],
          displayMath: [['$$', '$$']]
        },
        svg: {
          fontCache: 'global'
        }
      };
      _this.state = {
        isScriptLoaded: false
      };
      _this.loadScript();
    }
    return _this;
  }

  // load mathjax 
  _createClass(LoadScript, [{
    key: "render",
    value: function render() {
      var isScriptLoaded = this.state.isScriptLoaded;
      return isScriptLoaded ? this.props.children : /*#__PURE__*/React.createElement(Loading, null);
    }
  }]);
  return LoadScript;
}(React.Component);
export default LoadScript;